import React from 'react';
import './ToolButtons.css';
import { useTranslation } from '../../i18n/LanguageContext';

interface ToolButtonsProps {
  idle?: boolean;
  onTimerClick?: () => void;
  onDressClick?: () => void;
  onStatsClick?: () => void;
  onCameraClick?: () => void;
  isBgmPlaying?: boolean;
}

const ToolButtons: React.FC<ToolButtonsProps> = ({
  idle = false,
  onTimerClick,
  onDressClick,
  onStatsClick,
  // onCameraClick, // temporarily hidden
  // isBgmPlaying, // moved to mini player
}) => {
  const { t } = useTranslation();
  
  if (idle) return null;

  return (
    <div className="tool-button-box py-4 px-1 bg-black/30 border border-white rounded-full flex flex-col items-center gap-4">
      {/* タイマーボタン */}
      <button onClick={onTimerClick} className="flex flex-col items-center" aria-label="Timer">
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="13" r="8" stroke="white" strokeWidth="2" fill="none" opacity="0.9" />
          <path d="M12 9v4l2.5 2.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.9" />
          <path d="M9 2h6" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.9" />
          <path d="M12 2v3" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.9" />
        </svg>
        <span className="text-xs text-white opacity-70">Timer</span>
      </button>

      {/* 着せ替えボタン */}
      <button onClick={onDressClick} className="flex flex-col items-center" aria-label={t('tools.dress')}>
        <img src="/assets/img/dressico.svg" alt="Dressup" className="w-6 h-6" />
        <span className="text-xs text-white opacity-70">{t('tools.dress')}</span>
      </button>

      {/* 統計ボタン */}
      <button onClick={onStatsClick} className="flex flex-col items-center" aria-label={t('tools.stats')}>
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="14" width="4" height="6" fill="white" opacity="0.9" />
          <rect x="10" y="10" width="4" height="10" fill="white" opacity="0.9" />
          <rect x="16" y="6" width="4" height="14" fill="white" opacity="0.9" />
        </svg>
        <span className="text-xs text-white opacity-70">{t('tools.stats')}</span>
      </button>

      {/* カメラボタン（一時非表示） */}
      {/* <button onClick={onCameraClick} className="flex flex-col items-center" aria-label={t('tools.camera')}>
        <img id="camera-btn-icon" src="/assets/img/camera.svg" alt="Camera" className="w-6 h-6" />
        <span className="text-xs text-white opacity-70">{t('tools.camera')}</span>
      </button> */}
    </div>
  );
};

export default ToolButtons;